import {
  buildExecutionRunDetailPath,
  buildResultsFileDetailPath,
} from '@/features/shared/components/tableSystem/tableRoutes';
import { resolveEntityTags, resolveTagColor } from '@/features/shared/tags';
import { getStatusCopy } from '@/shared/copy/status';
import type { TagColor } from '@/shared/data/tags';
import type { ExecutionRunDto } from '@flowqa/shared';

const noDataLabel = getStatusCopy('noData');

export type ExecutionRunRunSummary = {
  primary: {
    label: string;
    href: string;
    isIdFallback: boolean;
  };
  secondary: {
    label: string;
    href: string | null;
  } | null;
  tags: Array<{ label: string; tone: TagColor }>;
};

export const resolveExecutionRunRunSummary = (
  executionRun: ExecutionRunDto,
  tagColorByName: Partial<Record<string, TagColor>> = {},
): ExecutionRunRunSummary => {
  const trimmedName = executionRun.name?.trim();
  const primaryLabel = trimmedName && trimmedName.length > 0 ? trimmedName : executionRun.id;
  const trimmedResultsFileName = executionRun.resultsFileName?.trim();
  const resultsFileLabel =
    trimmedResultsFileName && trimmedResultsFileName.length > 0
      ? trimmedResultsFileName
      : (executionRun.resultsFileSlug ?? noDataLabel);
  const resultsFileHref = buildResultsFileDetailPath(
    executionRun.resultsFileSlug ?? executionRun.resultsFileId,
  );
  const showResultsFileUnderName =
    resultsFileLabel !== noDataLabel && resultsFileLabel !== primaryLabel;
  const tags = resolveEntityTags(executionRun).map((tag) => ({
    label: tag,
    tone: resolveTagColor(tag, tagColorByName),
  }));

  return {
    primary: {
      label: primaryLabel,
      href: buildExecutionRunDetailPath(executionRun.id) ?? '/execution-runs',
      isIdFallback: primaryLabel === executionRun.id,
    },
    secondary: showResultsFileUnderName
      ? {
          label: resultsFileLabel,
          href: resultsFileHref,
        }
      : null,
    tags,
  };
};
